module.exports = SoftSetHook;

function SoftSetHook(value) {
    if (!(this instanceof SoftSetHook)) {
        return new SoftSetHook(value);
    }

    this.value = value;
}

SoftSetHook.prototype.hook = function (node, propertyName) {
    if (node[propertyName] !== this.value) {
        node[propertyName] = this.value;
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/hooks/soft-set-hook.js
// module id = 196
// module chunks = 0